export const countries = [
    {"value":"Canada", "name":"Canada"},
    {"value":"United States", "name":"United States"},
    {"value":"Afghanistan", "name":"Afghanistan"},
    {"value":"AlandIslands", "name":"Aland Islands"},
    {"value":"Albania", "name":"Albania"},
    {"value":"Algeria", "name":"Algeria"},
    {"value":"AmericanSamoa", "name":"American Samoa"},
    {"value":"Andorra", "name":"Andorra"},
    {"value":"Angola", "name":"Angola"},
    {"value":"Anguilla", "name":"Anguilla"},
    {"value":"Antarctica", "name":"Antarctica"},
    {"value":"AntiguaBarbubda", "name":"Antigua Barbuda"},
    {"value":"Argentina", "name":"Argentina"},
    {"value":"Armenia", "name":"Armenia"},
    {"value":"Aruba", "name":"Aruba"},
    {"value":"Australia", "name":"Australia"},
    {"value":"Austria", "name":"Austria"},
    {"value":"Azerbaidjan", "name":"Azerbaidjan"},
    {"value":"Bahamas", "name":"Bahamas"},
    {"value":"Bahrain", "name":"Bahrain"},
    {"value":"Bangladesh", "name":"Bangladesh"},
    {"value":"Barbados", "name":"Barbados"},
    {"value":"Belarus", "name":"Belarus"},
    {"value":"Belgium", "name":"Belgium"},
    {"value":"Belize", "name":"Belize"},
    {"value":"Benin", "name":"Benin"},
    {"value":"Bermuda", "name":"Bermuda"},
    {"value":"Bhutan", "name":"Bhutan"},
    {"value":"Bolivia", "name":"Bolivia"},
    {"value":"BonairStEustSaba", "name":"Bonair St Eust S"},
    {"value":"BosniaHerzegovi", "name":"Bosnia-Herzegovi"},
    {"value":"Botswana", "name":"Botswana"},
    {"value":"BouvetIsland", "name":"Bouvet Island"},
    {"value":"Brazil", "name":"Brazil"},
    {"value":"BritishIO", "name":"British IO"},
    {"value":"Brunei", "name":"Brunei Darussala"},
    {"value":"Bulgaria", "name":"Bulgaria"},
    {"value":"BurkinaFaso", "name":"Burkina Faso"},
    {"value":"Burundi", "name":"Burundi"},
    {"value":"Cambodia", "name":"Cambodia"},
    {"value":"Cameroon", "name":"Cameroon"},
    {"value":"CaboVerde", "name":"Cabo Verde"},
    {"value":"CaymanIslands", "name":"Cayman Islands"},
    {"value":"CentralAfrican", "name":"Central African"},
    {"value":"Chad", "name":"Chad"},
    {"value":"Chile", "name":"Chile"},
    {"value":"China", "name":"China"},
    {"value":"ChristmasIsland", "name":"Christmas Island"},
    {"value":"CocosIsland", "name":"Cocos Island"},
    {"value":"Colombia", "name":"Colombia"},
    {"value":"Comoros", "name":"Comoros"},
    {"value":"Congo", "name":"Congo"},
    {"value":"CongoDemRep", "name":"Congo, Dem. Rep"},
    {"value":"CookIslands", "name":"Cook Islands"},
    {"value":"CostaRica", "name":"Costa Rica"},
    {"value":"CoteDIvoire", "name":"Cote D'Ivoire"},
    {"value":"Croatia", "name":"Croatia"},
    {"value":"Cuba", "name":"Cuba"},
    {"value":"Cyprus", "name":"Cyprus"},
    {"value":"Czechia", "name":"Czechia"},
    {"value":"Denmark", "name":"Denmark"},
    {"value":"Djibouti", "name":"Djibouti"},
    {"value":"Dominica", "name":"Dominica"},
    {"value":"DominicanRep", "name":"Dominican Rep"},
    {"value":"Ecuador", "name":"Ecuador"},
    {"value":"Egypt", "name":"Egypt"},
    {"value":"ElSalvador", "name":"El Salvador"},
    {"value":"EquatorGuinea", "name":"Equator Guinea"},
    {"value":"Eritrea", "name":"Eritrea"},
    {"value":"Estonia", "name":"Estonia"},
    {"value":"Ethiopia", "name":"Ethiopia"},
    {"value":"FalklandIslands", "name":"Falkland Islands"},
    {"value":"FaroeIslands", "name":"Faroe Islands"},
    {"value":"Fiji", "name":"Fiji"},
    {"value":"Finland", "name":"Finland"},
    {"value":"France", "name":"France"},
    {"value":"FrenchGuiana", "name":"French Guiana"},
    {"value":"FrenchPolynesia", "name":"French Polynesia"},
    {"value":"FrenchSTerr", "name":"French S Terr"},
    {"value":"Gabon", "name":"Gabon"},
    {"value":"Gambia", "name":"Gambia"},
    {"value":"Georgia", "name":"Georgia"},
    {"value":"Germany", "name":"Germany"},
    {"value":"Ghana", "name":"Ghana"},
    {"value":"Gibraltar", "name":"Gibraltar"},
    {"value":"Greece", "name":"Greece"},
    {"value":"Greenland", "name":"Greenland"},
    {"value":"Grenada", "name":"Grenada"},
    {"value":"Guadaloupe", "name":"Guadaloupe"},
    {"value":"Guam", "name":"Guam"},
    {"value":"Guatemala", "name":"Guatemala"},
    {"value":"Guernsey", "name":"Guernsey"},
    {"value":"Guinea", "name":"Guinea"},
    {"value":"GuineaBissau", "name":"Guinea-Bissau"},
    {"value":"Guyana", "name":"Guyana"},
    {"value":"Haiti", "name":"Haiti"},
    {"value":"HeardMcDonald", "name":"Heard & McDonald"},
    {"value":"HolySee", "name":"Holy See"},
    {"value":"Honduras", "name":"Honduras"},
    {"value":"HongKong", "name":"Hong Kong"},
    {"value":"Hungary", "name":"Hungary"},
    {"value":"Iceland", "name":"Iceland"},
    {"value":"India", "name":"India"},
    {"value":"Indonesia", "name":"Indonesia"},
    {"value":"Iran", "name":"Iran"},
    {"value":"Iraq", "name":"Iraq"},
    {"value":"Ireland", "name":"Ireland"},
    {"value":"IsleOfMan", "name":"Isle of Man"},
    {"value":"Israel", "name":"Israel"},
    {"value":"Italy", "name":"Italy"},
    {"value":"Jamaica", "name":"Jamaica"},
    {"value":"Japan", "name":"Japan"},
    {"value":"Jersey", "name":"Jersey"},
    {"value":"Jordan", "name":"Jordan"},
    {"value":"Kazakhstan", "name":"Kazakhstan"},
    {"value":"Kenya", "name":"Kenya"},
    {"value":"Kiribati", "name":"Kiribati"},
    {"value":"Korea", "name":"Korea"},
    {"value":"KoreaDPR", "name":"Korea (DPR)"},
    {"value":"Kuwait", "name":"Kuwait"},
    {"value":"Kyrgyzstan", "name":"Kyrgyzstan"},
    {"value":"LaoPDR", "name":"Lao (PDR)"},
    {"value":"Latvia", "name":"Latvia"},
    {"value":"Lebanon", "name":"Lebanon"},
    {"value":"Lesotho", "name":"Lesotho"},
    {"value":"Liberia", "name":"Liberia"},
    {"value":"Libya", "name":"Libya"},
    {"value":"Lichtenstein", "name":"Lichtenstein"},
    {"value":"Lithuania", "name":"Lithuania"},
    {"value":"Luxembourg", "name":"Luxembourg"},
    {"value":"Macao", "name":"Macao"},
    {"value":"Macedonia", "name":"Macedonia"},
    {"value":"Madagascar", "name":"Madagascar"},
    {"value":"Malawi", "name":"Malawi"},
    {"value":"Malaysia", "name":"Malaysia"},
    {"value":"Maldives", "name":"Maldives"},
    {"value":"Mali", "name":"Mali"},
    {"value":"Malta", "name":"Malta"},
    {"value":"Martinique", "name":"Martinique"},
    {"value":"MarshallIslands", "name":"Marshall Islands"},
    {"value":"Mauritania", "name":"Mauritania"},
    {"value":"Mauritius", "name":"Mauritius"},
    {"value":"Mexico", "name":"Mexico"},
    {"value":"Micronesia", "name":"Micronesia"},
    {"value":"Moldova", "name":"Moldova"},
    {"value":"Monaco", "name":"Monaco"},
    {"value":"Mongolia", "name":"Mongolia"},
    {"value":"Montenegro", "name":"Montenegro"},
    {"value":"Montserrat", "name":"Montserrat"},
    {"value":"Morocco", "name":"Morocco"},
    {"value":"Mozambique", "name":"Mozambique"},
    {"value":"Myanmar", "name":"Myanmar"},
    {"value":"NMarianaIsl", "name":"N Mariana Isl"},
    {"value":"Nambia", "name":"Nambia"},
    {"value":"Nauru", "name":"Nauru"},
    {"value":"Nepal", "name":"Nepal"},
    {"value":"Netherlands", "name":"Netherlands"},
    {"value":"NewCalendonia", "name":"New Calendonia"},
    {"value":"NewZealand", "name":"New Zealand"},
    {"value":"Nicaragua", "name":"Nicaragua"},
    {"value":"Niger", "name":"Niger"},
    {"value":"Nigeria", "name":"Nigeria"},
    {"value":"Niue", "name":"Niue"},
    {"value":"NorfolkIsland", "name":"Norfolk Island"},
    {"value":"Norway", "name":"Norway"},
    {"value":"Oman", "name":"Oman"},
    {"value":"Pakistan", "name":"Pakistan"},
    {"value":"Palau", "name":"Palau"},
    {"value":"Palestine", "name":"Palestine"},
    {"value":"Panama", "name":"Panama"},
    {"value":"PapuaNewGuinea", "name":"Papua New Guinea"},
    {"value":"Paraguay", "name":"Paraguay"},
    {"value":"Peru", "name":"Peru"},
    {"value":"Philippines", "name":"Philippines"},
    {"value":"PitcairnIslands", "name":"Pitcairn Islands"},
    {"value":"Poland", "name":"Poland"},
    {"value":"Portugal", "name":"Portugal"},
    {"value":"PuertoRico", "name":"Puerto Rico"},
    {"value":"Qatar", "name":"Qatar"},
    {"value":"Reunion", "name":"Reunion"},
    {"value":"Romania", "name":"Romania"},
    {"value":"RussianFed", "name":"Russian Fed"},
    {"value":"Rwanda", "name":"Rwanda"},
    {"value":"SainBarthelemy", "name":"Saint Barthelemy"},
    {"value":"Samoa", "name":"Samoa"},
    {"value":"SanMarino", "name":"San Marino"},
    {"value":"SaoTome", "name":"Sao Tome & Princ"},
    {"value":"SaudiArabia", "name":"Saudi Arabia"},
    {"value":"Senegal", "name":"Senegal"},
    {"value":"Serbia", "name":"Serbia"},
    {"value":"Seychelles", "name":"Seychelles"},
    {"value":"SierraLeone", "name":"Sierra Leone"},
    {"value":"Singapore", "name":"Singapore"},
    {"value":"SlovakRepublic", "name":"Slovak Republic"},
    {"value":"Slovenia", "name":"Slovenia"},
    {"value":"SolomonIslands", "name":"Solomon Islands"},
    {"value":"Somalia", "name":"Somalia"},
    {"value":"SouthAfrica", "name":"South Africa"},
    {"value":"SGeorgia", "name":"S Georgia SS Isl"},
    {"value":"SouthSudan", "name":"South Sudan"},
    {"value":"Spain", "name":"Spain"},
    {"value":"SriLanka", "name":"Sri Lanka"},
    {"value":"StHelena", "name":"St. Helena"},
    {"value":"StKitts", "name":"St Kitts & Nevis"},
    {"value":"StLucia", "name":"St. Lucia"},
    {"value":"StMaartenDutch", "name":"St Maarten Dutch"},
    {"value":"StMartinFrench", "name":"St Martin French"},
    {"value":"StPierre", "name":"St Pierre & Miqu"},
    {"value":"StVincent", "name":"St Vincent Grena"},
    {"value":"Sudan", "name":"Sudan"},
    {"value":"Suriname", "name":"Suriname"},
    {"value":"Svalbard", "name":"Svalbard Jan May"},
    {"value":"Swaziland", "name":"Swaziland"},
    {"value":"Sweden", "name":"Sweden"},
    {"value":"Switzerland", "name":"Switzerland"},
    {"value":"Syria", "name":"Syrian Arab Rep"},
    {"value":"Taiwan", "name":"Taiwan (China)"},
    {"value":"Tajikistan", "name":"Tajikistan"},
    {"value":"Tanzania", "name":"Tanzania"},
    {"value":"Thailand", "name":"Thailand"},
    {"value":"TimoreLeste", "name":"Timore-Leste"},
    {"value":"Togo", "name":"Togo"},
    {"value":"Tokelau", "name":"Tokelau"},
    {"value":"Tonga", "name":"Tonga"},
    {"value":"Trinidad", "name":"Trinidad Tobago"},
    {"value":"Tunisia", "name":"Tunisia"},
    {"value":"Turkey", "name":"Turkey"},
    {"value":"Turkmenistan", "name":"Turkmenistan"},
    {"value":"TurksCaicos", "name":"Turks & Caicos"},
    {"value":"Tuvalu", "name":"Tuvalu"},
    {"value":"Uganda", "name":"Uganda"},
    {"value":"Ukraine", "name":"Ukraine"},
    {"value":"UnitedArabEmir", "name":"United Arab Emir"},
    {"value":"UnitedKingdom", "name":"United Kingdom"},
    {"value":"Uruguay", "name":"Uruguay"},
    {"value":"USMinorIslands", "name":"US Minor Islands"},
    {"value":"Uzbekistan", "name":"Uzbekistan"},
    {"value":"Vanuatu", "name":"Vanuatu"},
    {"value":"Venezuela", "name":"Venezuela"},
    {"value":"VietNam", "name":"Viet Nam"},
    {"value":"VirginIslBr", "name":"Virgin Isl,Br"},
    {"value":"VirginIslUS", "name":"Virgin Isl,US"},
    {"value":"Wallis", "name":"Wallis & Futuna"},
    {"value":"WesternSahara", "name":"Western Sahara"},
    {"value":"Yemen", "name":"Yemen"},
    {"value":"Zambia", "name":"Zambia"},
    {"value":"Zimbabwe", "name":"Zimbabwe"}
]